// 초기화
const initialStete = {
  stores: false,
};

// 리듀서 작성
// function global_loading(state = initialStete, action) {
export const global_loading = (state = initialStete, action) => {
  switch (action.type) {
    case "loading/GLOBAL_STATE/ON": {
      return { ...state, stores: action.payload };
    }
    case "loading/GLOBAL_STATE/OFF":
      return { ...state, stores: action.payload };
    default:
      return state;
  }
};
